/* unplugin-vue-components disabled */import { render } from "./CalendarCards.vue?vue&type=template&id=550acfa1&ts=true"
import script from "./CalendarCards.vue?vue&type=script&lang=ts"
export * from "./CalendarCards.vue?vue&type=script&lang=ts"

import "./CalendarCards.vue?vue&type=style&index=0&id=550acfa1&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__